import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"height":"100%","display":"flex","flex-direction":"column"}
}
const _hoisted_2 = { style: {"flex-grow":"0","display":"flex","padding":"1em 0 2em"} }
const _hoisted_3 = { class: "me-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: ""
}, "MIDI Device", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Please select input", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "me-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: ""
}, "Lowest C", -1)
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<option value=\"12\">C0</option><option value=\"24\">C1</option><option value=\"36\">C2</option><option value=\"48\">C3</option><option value=\"60\">C4</option><option value=\"72\">C5</option><option value=\"84\">C6</option>", 7)
const _hoisted_16 = [
  _hoisted_9
]
const _hoisted_17 = { class: "me-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: ""
}, "Octaves", -1)
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<option value=\"1\">1</option><option value=\"2\">2</option><option value=\"3\">3</option><option value=\"4\">4</option><option value=\"5\">5</option><option value=\"6\">6</option><option value=\"7\">7</option>", 7)
const _hoisted_26 = [
  _hoisted_19
]
const _hoisted_27 = { style: {"flex-grow":"1","display":"flex","align-items":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KeyboardView = _resolveComponent("KeyboardView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.midi)
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              class: "form-select",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentInput) = $event))
            }, [
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputs, (input) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: input.id,
                  value: input
                }, _toDisplayString(input.name), 9, _hoisted_6))
              }), 128))
            ], 512)), [
              [_vModelSelect, _ctx.currentInput]
            ])
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("select", {
          class: "form-select",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lowestC) = $event))
        }, _hoisted_16, 512), [
          [
            _vModelSelect,
            _ctx.lowestC,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _withDirectives(_createElementVNode("select", {
          class: "form-select",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.octaves) = $event))
        }, _hoisted_26, 512), [
          [
            _vModelSelect,
            _ctx.octaves,
            void 0,
            { number: true }
          ]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      (_ctx.currentInput)
        ? (_openBlock(), _createBlock(_component_KeyboardView, {
            key: 0,
            notesOn: _ctx.notesOn,
            octaves: _ctx.octaves,
            lowestC: _ctx.lowestC
          }, null, 8, ["notesOn", "octaves", "lowestC"]))
        : _createCommentVNode("", true)
    ])
  ]))
}